/**
 * Build Your PC — configurator logic (v2)
 * Product cards are now fetched client-side from each collection's public
 * /collections/{handle}/products.json endpoint. This avoids Shopify Liquid's
 * hard 50-item cap on `collection.products` so collections with 100+ SKUs
 * work correctly, and lets us filter to in-stock-only + paginate with a
 * "Load more" button per step.
 */
window.BuildYourPC = (function () {
  var JSON_PAGE_LIMIT = 250; // Shopify's max allowed limit for /products.json

  function init(sectionId, options) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    var batchSize = options.batchSize || 30;
    var state = {};       // stepKey -> selection object OR array of selection objects (multi steps)
    var stepData = {};    // stepKey -> { buffer:[], jsonPage:1, exhausted:false, loading:false, revealedIds:Set, stepEl, requirement }

    var stepEls = root.querySelectorAll('.byo-step');
    var sidebarList = root.querySelector('.byo-sidebar-list');
    var totalEl = root.querySelector('.byo-sidebar-total');
    var addCartBtn = root.querySelector('.byo-add-cart-btn');
    var whatsappBtn = root.querySelector('.byo-whatsapp-btn');
    var errorEl = root.querySelector('.byo-sidebar-error');
    var refEl = root.querySelector('.byo-ref-code');

    if (refEl) refEl.textContent = Date.now().toString(36).toUpperCase().slice(-6);

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var intPart = parts[0];
      var lastThree = intPart.substring(intPart.length - 3);
      var otherNumbers = intPart.substring(0, intPart.length - 3);
      if (otherNumbers !== '') lastThree = ',' + lastThree;
      var formattedInt = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
      return 'Rs. ' + formattedInt + '.' + parts[1];
    }

    function isMultiStep(stepEl) {
      var req = stepEl.getAttribute('data-requirement');
      return req === 'multi_select' || req === 'optional_multi';
    }

    function isOptionalStep(stepEl) {
      var req = stepEl.getAttribute('data-requirement');
      return req === 'optional_single' || req === 'optional_multi';
    }

    // ---------- Selection state ----------

    function selectSingle(stepEl, cardEl, data) {
  var stepKey = stepEl.getAttribute('data-step-key');
  var currentSelection = state[stepKey];

  /*
   * If the same product is clicked again,
   * remove it from the selection.
   */
  if (
    currentSelection &&
    String(currentSelection.productId) === String(data.productId)
  ) {
    delete state[stepKey];
    cardEl.classList.remove('byo-selected');

    render();
    return;
  }

  /*
   * Otherwise, remove the previous selection
   * and select the newly clicked product.
   */
  stepEl.querySelectorAll('.byo-card').forEach(function (card) {
    card.classList.remove('byo-selected');
  });

  cardEl.classList.add('byo-selected');
  state[stepKey] = data;

  var skipBtn = stepEl.querySelector('.byo-skip-btn');

  if (skipBtn) {
    skipBtn.classList.remove('byo-skip-active');
  }

  render();
}

    function toggleMulti(stepEl, cardEl, data) {
      var stepKey = stepEl.getAttribute('data-step-key');
      if (!Array.isArray(state[stepKey])) state[stepKey] = [];
      var idx = state[stepKey].findIndex(function (i) { return i.productId === data.productId; });
      if (idx > -1) {
        state[stepKey].splice(idx, 1);
        cardEl.classList.remove('byo-selected');
      } else {
        state[stepKey].push(data);
        cardEl.classList.add('byo-selected');
      }
      if (state[stepKey].length === 0) delete state[stepKey];
      render();
    }

    function skipStep(stepEl) {
      var stepKey = stepEl.getAttribute('data-step-key');
      delete state[stepKey];
      stepEl.querySelectorAll('.byo-card').forEach(function (c) { c.classList.remove('byo-selected'); });
      var skipBtn = stepEl.querySelector('.byo-skip-btn');
      if (skipBtn) skipBtn.classList.add('byo-skip-active');
      render();
    }

    root.querySelectorAll('.byo-skip-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepEl = document.getElementById('byo-step-' + btn.getAttribute('data-step-key'));
        if (stepEl) skipStep(stepEl);
      });
    });

    // ---------- Card building ----------

    function bestVariant(product) {
      var available = product.variants.filter(function (v) { return v.available; });
      return available[0] || product.variants[0];
    }

    function buildCard(product, stepEl, stepKey, stepName) {
      var variant = bestVariant(product);
      var priceCents = Math.round(parseFloat(variant.price) * 100);
      var image = (product.images && product.images[0]) ? product.images[0].src : '';

      var card = document.createElement('div');
      card.className = 'byo-card';
      card.setAttribute('data-step-key', stepKey);
      card.setAttribute('data-product-id', String(product.id));
      card.setAttribute('data-variant-id', String(variant.id));
      card.setAttribute('data-price', String(priceCents));
      card.setAttribute('data-title', product.title);
      card.setAttribute('data-image', image);
      card.setAttribute('data-handle', product.handle);

      var html = '';
      if (image) {
        html += '<img class="byo-card-img" src="' + image + '&width=300" loading="lazy" alt="' + escapeHtml(product.title) + '">';
      }
      html += '<p class="byo-card-title">' + escapeHtml(product.title) + '</p>';
      html += '<p class="byo-card-price">' + formatMoney(priceCents) + '</p>';

      if (product.variants.length > 1) {
        html += '<select class="byo-variant-select">';
        product.variants.forEach(function (v) {
          var vCents = Math.round(parseFloat(v.price) * 100);
          html += '<option value="' + v.id + '" data-price="' + vCents + '"' +
            (v.available ? '' : ' disabled') +
            (v.id === variant.id ? ' selected' : '') + '>' +
            escapeHtml(v.title) + ' — ' + formatMoney(vCents) + (v.available ? '' : ' (Sold out)') +
            '</option>';
        });
        html += '</select>';
      }

      html += '<button type="button" class="byo-select-btn">' +
        '<span class="byo-select-label">Select</span>' +
        '<span class="byo-selected-check">✓ Selected</span>' +
      '</button>';

      card.innerHTML = html;

      function currentData() {
        return {
          variantId: card.getAttribute('data-variant-id'),
          productId: card.getAttribute('data-product-id'),
          price: parseInt(card.getAttribute('data-price'), 10) || 0,
          title: card.getAttribute('data-title'),
          image: card.getAttribute('data-image'),
          stepName: stepName
        };
      }

      card.addEventListener('click', function (e) {
        if (e.target.classList.contains('byo-variant-select')) return;
        var data = currentData();
        if (isMultiStep(stepEl)) {
          toggleMulti(stepEl, card, data);
        } else {
          selectSingle(stepEl, card, data);
        }
      });

      var variantSelect = card.querySelector('.byo-variant-select');
      if (variantSelect) {
        variantSelect.addEventListener('click', function (e) { e.stopPropagation(); });
        variantSelect.addEventListener('change', function (e) {
          e.stopPropagation();
          var opt = variantSelect.options[variantSelect.selectedIndex];
          card.setAttribute('data-variant-id', opt.value);
          card.setAttribute('data-price', opt.getAttribute('data-price'));
          var priceEl = card.querySelector('.byo-card-price');
          if (priceEl) priceEl.textContent = formatMoney(parseInt(opt.getAttribute('data-price'), 10));

          if (card.classList.contains('byo-selected')) {
            var data = currentData();
            if (isMultiStep(stepEl)) {
              var stepKeyLocal = stepEl.getAttribute('data-step-key');
              var idx = state[stepKeyLocal].findIndex(function (i) { return i.productId === data.productId; });
              if (idx > -1) state[stepKeyLocal][idx] = data;
              render();
            } else {
              selectSingle(stepEl, card, data);
            }
          }
        });
      }

      return card;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    // ---------- Fetching / pagination per step ----------

    function fetchJsonPage(handle, page) {
      var url = '/collections/' + handle + '/products.json?limit=' + JSON_PAGE_LIMIT + '&page=' + page;
      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error('Failed to load products for ' + handle);
        return res.json();
      }).then(function (data) {
        return data.products || [];
      });
    }

    function ensureBuffer(sd) {
      // Pulls JSON pages until buffer has enough in-stock products or the collection is exhausted.
      if (sd.buffer.length >= batchSize || sd.exhausted) {
        return Promise.resolve();
      }
      return fetchJsonPage(sd.handle, sd.jsonPage).then(function (products) {
        sd.jsonPage += 1;
        if (products.length < JSON_PAGE_LIMIT) sd.exhausted = true;

        products.forEach(function (p) {

  // Check if at least one variant is available
  var hasAvailableVariant = false;

  if (p.variants && p.variants.length) {
    hasAvailableVariant = p.variants.some(function(v) {
      return v.available;
    });
  }

  if (
    hasAvailableVariant &&
    !sd.revealedIds.has(p.id) &&
    !sd.bufferedIds.has(p.id)
  ) {
    sd.buffer.push(p);
    sd.bufferedIds.add(p.id);
  }

});

        if (sd.buffer.length < batchSize && !sd.exhausted) {
          return ensureBuffer(sd);
        }
      });
    }

    function revealNextBatch(stepKey) {
      var sd = stepData[stepKey];
      if (!sd || sd.loading) return;
      sd.loading = true;

      var loadingLabel = document.getElementById('byo-loading-' + stepKey);
      var loadMoreBtn = document.getElementById('byo-loadmore-' + stepKey);
      var noMoreLabel = document.getElementById('byo-nomore-' + stepKey);
      if (loadingLabel) loadingLabel.style.display = 'block';
      if (loadMoreBtn) loadMoreBtn.style.display = 'none';

      ensureBuffer(sd).then(function () {
        var batch = sd.buffer.splice(0, batchSize);
        var row = document.getElementById('byo-row-' + stepKey);
        var stepName = sd.stepEl.getAttribute('data-step-name');

        batch.forEach(function (product) {
          sd.revealedIds.add(product.id);
          var card = buildCard(product, sd.stepEl, stepKey, stepName);
          row.appendChild(card);
        });

        sd.loading = false;
        if (loadingLabel) loadingLabel.style.display = 'none';

        var hasMore = sd.buffer.length > 0 || !sd.exhausted;
        if (loadMoreBtn) loadMoreBtn.style.display = hasMore ? 'block' : 'none';
        if (noMoreLabel) noMoreLabel.style.display = (!hasMore && sd.revealedIds.size > 0) ? 'block' : 'none';
      }).catch(function (err) {
        sd.loading = false;
        if (loadingLabel) loadingLabel.textContent = 'Could not load products for this step.';
        console.error('BuildYourPC product fetch error:', err);
      });
    }

    stepEls.forEach(function (stepEl) {
      var handle = stepEl.getAttribute('data-collection-handle');
      var stepKey = stepEl.getAttribute('data-step-key');
      if (!handle) return; // no collection assigned — Liquid already shows a placeholder message

      stepData[stepKey] = {
        handle: handle,
        buffer: [],
        bufferedIds: new Set(),
        revealedIds: new Set(),
        jsonPage: 1,
        exhausted: false,
        loading: false,
        stepEl: stepEl
      };

      var loadMoreBtn = document.getElementById('byo-loadmore-' + stepKey);
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () { revealNextBatch(stepKey); });
      }

      revealNextBatch(stepKey);
    });

    // ---------- Sidebar / total / actions ----------

    function flattenState() {
      var items = [];
      Object.keys(state).forEach(function (key) {
        var val = state[key];
        if (Array.isArray(val)) { val.forEach(function (i) { items.push(i); }); }
        else { items.push(val); }
      });
      return items;
    }

    function allRequiredFilled() {
      var missing = [];
      stepEls.forEach(function (stepEl) {
        if (isOptionalStep(stepEl)) return;
        var stepKey = stepEl.getAttribute('data-step-key');
        var val = state[stepKey];
        var filled = Array.isArray(val) ? val.length > 0 : !!val;
        if (!filled) missing.push(stepEl.getAttribute('data-step-name'));
      });
      return missing;
    }

    function render() {
      var items = flattenState();
      var total = items.reduce(function (sum, i) { return sum + i.price; }, 0);

      if (items.length === 0) {
        sidebarList.innerHTML = '<p class="byo-sidebar-empty">Nothing selected yet — pick a part from each station.</p>';
      } else {
        sidebarList.innerHTML = items.map(function (i) {
          return '<div class="byo-sidebar-item">' +
            '<span class="byo-sidebar-item-label">' + escapeHtml(i.stepName) + '</span>' +
            '<span class="byo-sidebar-item-title">' + escapeHtml(i.title) + '</span>' +
            '<span class="byo-sidebar-item-price">' + formatMoney(i.price) + '</span>' +
          '</div>';
        }).join('');
      }

      totalEl.textContent = formatMoney(total);

      var missing = allRequiredFilled();
      var ready = missing.length === 0 && items.length > 0;
      addCartBtn.disabled = !ready;
      whatsappBtn.disabled = !ready;

      if (errorEl) {
        errorEl.textContent = (!ready && items.length > 0) ? 'Still need: ' + missing.join(', ') : '';
      }
    }

    addCartBtn.addEventListener('click', function () {
      var items = flattenState();
      if (items.length === 0) return;

      addCartBtn.disabled = true;
      addCartBtn.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items.map(function (i) { return { id: i.variantId, quantity: 1 }; })
        })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          window.location.href = options.cartUrl || '/cart';
        })
        .catch(function (err) {
          addCartBtn.disabled = false;
          addCartBtn.textContent = 'ADD BUILD TO CART';
          if (errorEl) errorEl.textContent = 'Could not add build to cart — one or more items may be sold out.';
          console.error('BuildYourPC add to cart error:', err);
        });
    });

    whatsappBtn.addEventListener('click', function () {
      var items = flattenState();
      if (items.length === 0) return;

      var total = items.reduce(function (sum, i) { return sum + i.price; }, 0);
      var lines = [options.whatsappIntro || 'Hi! My PC build spec:'];

      items.forEach(function (i) {
        lines.push('\u2022 ' + i.stepName + ': ' + i.title + ' \u2014 ' + formatMoney(i.price));
      });

      lines.push('TOTAL: ' + formatMoney(total));
      lines.push('Please review my build.');

      var message = encodeURIComponent(lines.join('\n'));
      var phone = (options.whatsappNumber || '').replace(/[^0-9]/g, '');
      var url = 'https://wa.me/' + phone + '?text=' + message;
      window.open(url, '_blank');
    });

    render();
  }

  return { init: init };
})();
